module.exports = __webpack_public_path__ + "static/media/share_lightbox.f5226371.svg";